import React, { useState } from 'react';
import FileUpload from "./FileUpload";

const AddDocumentModal = ({ onConfirm, onCancel }) => {
  const [name, setName] = useState('');
  const [file, setFile] = useState(null);

  const handleConfirm = () => {
     onConfirm({ name, file });
  };

  const handleCancel = () => {
     setName("");
     setFile(null);
     if(onCancel) onCancel();
  }


  const handleUpload = (file) => {
    setFile(file);
  }



  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <h2 className="modal-title">Aggiungi Documento</h2>

        <form className="modal-form" onSubmit={(e) => e.preventDefault()}>
          <div className="form-group">
            <label>Nome del Documento</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="form-input"
              placeholder="Inserisci un nome"
            />
          </div>

          {/*<div className="form-group">
            <label>Carica File</label>
            <input
              type="file"
              onChange={(e) => setFile(e.target.files[0])}
              className="form-input"
            />
          </div>*/}


          <FileUpload onFileUpload={handleUpload} />

        </form>


        <div className="buttons">
          <button onClick={handleCancel} className="modal-button cancel-button">Indietro</button>
          <button onClick={handleConfirm} className="modal-button confirm-button">Procedi</button>
        </div>
      </div>
    </div>
  );
};

export default AddDocumentModal;
